(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if (document.querySelector('.stikcy-overlay-tab') != null) {
        document.querySelector('.stikcy-overlay-tab').style.top = '0px';
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (document.querySelector('.stikcy-overlay-tab') != null) {
        var header_height = document.querySelector('header').offsetHeight;
        document.querySelector('.stikcy-overlay-tab').style.top = header_height + 'px';
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (document.querySelector('.stikcy-overlay-tab') != null) {
        var header_height = document.querySelector('header').offsetHeight;
        document.querySelector('.stikcy-overlay-tab').style.top = header_height + 'px';
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  function initMegaMenu() {
  var main_title = document.querySelectorAll('.header__inline-menu header-menu details>summary.header__menu-item');
  if (main_title.length !== 0) {
    main_title.forEach(function(item) {
      item.addEventListener("mouseenter", (em) => {
        var _this = em.target;
        if (!_this.classList.contains('header__menu-item')) {
          _this = _this.closest('.header__menu-item');
        }

        var mega_tab_list = _this.closest('.header__inline-menu').querySelectorAll('details>summary.header__menu-item');
        mega_tab_list.forEach(function(content) {
          content.closest('details').removeAttribute('open');
        });
        _this.closest('details').setAttribute('open', 'open');
      });
    });
  }

  var mouse_over = document.querySelector('header');
  if (mouse_over != null) {
    mouse_over.addEventListener("mouseleave", (em) => {
      var _this = em.target;
      if (!_this.classList.contains('header-wrapper')) {
        _this = _this.closest('.header-wrapper');
      }

      var mega_tab_list = _this.querySelectorAll('details>summary.header__menu-item');
      mega_tab_list.forEach(function(content) {
        content.closest('details').removeAttribute('open');
      });
    });
  }
}

  function destroyMegaMenu() {
    var main_title = document.querySelectorAll('.header__inline-menu header-menu details>summary.header__menu-item');
    main_title.forEach(function(item) {
      item.replaceWith(item.cloneNode(true)); 
    });

    var header = document.querySelector('header');
    if (header) {
      header.replaceWith(header.cloneNode(true));
    }
  }
  var mq = window.matchMedia("(min-width: 1440px)");
  function handleMediaQuery(e) {
    if (e.matches) {
      initMegaMenu();   
    } else {
      destroyMegaMenu(); 
    }
  }
  handleMediaQuery(mq);
  mq.addEventListener("change", handleMediaQuery);
  

  } catch(e) { console.error(e); }
})();
})();
